<template>
  <AdminLayout :title="$t('admin_point.point_manage_title1')" :current="$c.ADMIN.TAB.PERIOD">
    <Lock @click="chg_lock"></Lock>
    <div class="section">
      <div class="container">
        <div v-for="(item,k,i) in items" :key="i" class="unit">
          <p class="caption_label">{{$t(item.title)}}</p>
          <div class="unit leftright">
            <div style="width:85%" align="left">
              <b-form-input readonly class="admin-border inline-input" type="number" size="lg" v-model='item.cur_data'
                            :placeholder='$t("admin_point_setting.current_point")'></b-form-input>
              <b-icon icon="arrow-right" font-scale="1" style="color: gray; margin: 0 0.2em;"></b-icon>
              <b-form-input :readonly="!state" class="admin-border inline-input" type="number" size="lg" v-model='item.chg_data'
                            :placeholder='$t("admin_point_setting.point_to_apply")'></b-form-input>
            </div>
            <b-button variant="none" class="confirm_btn" @click="change(k)">
              {{$t('common.confirm')}}</b-button>
          </div>
        </div>
        <b-container style="margin-top:4em; padding-bottom: 0">
          <b-row v-for="item in but_group">
            <b-col> <p class="caption_label">{{$t(item.title)}}</p></b-col>
            <b-col v-for="button in item.buttons">
              <b-button size="lg" variant="none" :class='[(item.state === button.key) ?"primary_btn": "inactive_btn"]' @click="change(button.key)">
                {{$t(button.title)}}</b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <b-modal
      content-class="md_modal_content"
      centered
      :hide-header=true
      :hide-footer=true
      :id="k"
      v-for="(modal,k,i) in modals"
      :key="i"
    >
      <div align="center" style="margin: 0.5em;">
        <p style="padding: 0.8em;" v-html="modal.title"></p>
        <b-button
          style="width: 20%; margin-right: 1.5em;"
          @click="cancel_modal(k)"
          class="md_btn_light">{{$t('common.cancel1')}}</b-button>
        <b-button
          style="width: 20%"
          @click="ok_modal(k)"
          class="md_btn_primary">{{$t('common.ok')}}</b-button>
      </div>
    </b-modal>
  </AdminLayout>
</template>
<script>
import AdminLayout from './controls/adminlayout'
import Lock from './controls/lock'
import Utils from "../../../../config/utils";
import utils from "../../../../config/utils";
const $u = require('util');

export default {
  name: "AdminPeriod",
  components: {
    AdminLayout,
    Lock
  },
  data() {
    return {
      state: this.$store.getters.adminLock,
      but_group: {
        trans:{
          title: "admin_point_setting.convert_ticket",
          state: 'P',
          buttons: [
            {title: "admin_point_setting.free", key: 'F'},
            {title: "admin_point_setting.pay", key: 'P'},
          ],
        },
        display:{
          title: "admin_point_setting.show_ticket",
          state: 'Y',
          buttons: [
            {title: "admin_point_setting.show", key: 'Y'},
            {title: "admin_point_setting.hide", key: 'N'},
          ],
        },
      },

      items: {
        //cur_data에 현재값을 넣어야 합니다.!!!
        community_made_point: {title: "admin_point_setting.made_community_writing", cur_data: null, chg_data: null},
        notify_made_point: {title: "admin_point_setting.send_made_notification", cur_data: null, chg_data: null},
        community_push_point: {title: "admin_point_setting.community_writing_push", cur_data: null, chg_data: null},
        notify_push_point: {title: "admin_point_setting.send_push_notification", cur_data: null, chg_data: null},
        // { key:5, title:"admin_point_setting.send_push_notification"},
        // { key:6, title:"admin_point_setting.one_month_ticket"},
      },
      modals: {
        P: {
          title: $u.format(this.$t('admin_point_setting.confirm_change_ticket'),
            this.$t("admin_point_setting.free"), this.$t("admin_point_setting.pay")),
        },
        F: {
          title: $u.format(this.$t('admin_point_setting.confirm_change_ticket'),
            this.$t("admin_point_setting.pay"), this.$t("admin_point_setting.free")),
        },
        Y: {
          title: $u.format(this.$t('admin_point_setting.confirm_change_ticket_visible'),
            this.$t("admin_point_setting.show"),)
        },
        N: {
          title: $u.format(this.$t('admin_point_setting.confirm_change_ticket_visible'),
            this.$t("admin_point_setting.hide"))
        },
        community_made_point: {title: null},
        notify_made_point: {title: null},
        community_push_point: {title: null},
        notify_push_point: {title: null},
      }
    }
  },
  methods:{
    chg_lock:function (state){
      this.state = state;
      },
    change(key){
      if(this.state){
        var title, is_show = true;
        switch (key) {
          case 'community_made_point': title =this.$t('admin_point_setting.made_community_writing'); break;
          case 'notify_made_point': title =this.$t('admin_point_setting.send_made_notification'); break;
          case 'community_push_point': title =this.$t('admin_point_setting.community_writing_push'); break;
          case 'notify_push_point': title =this.$t('admin_point_setting.send_push_notification'); break;
          case 'F':
          case 'P': is_show = (this.but_group.trans.state !== key); break;
          case 'Y':
          case 'N': is_show = (this.but_group.display.state !== key); break;
        }
        if(this.items[key] !== undefined){
          this.modals[key].title = '['+title+']<br/>'+$u.format(this.$t('admin_point_setting.confirm_change_point'),
            this.items[key].cur_data,this.zero(this.items[key].chg_data));
        }
        if(is_show)
          this.$bvModal.show(key);
      }else{
        Utils.toast(this, this.$t('admin.unlock_hint'));
      }
    },

    cancel_modal(id){
      this.$bvModal.hide(id);
    },
    ok_modal(key) {
      switch (key){
        case 'F':
        case 'P':
          Utils.requestPost(
            this.$c.API.Admin.updateAppInfo,
            {
              param_name: 'ticket_price',
              value: key,
            }
          ).then(result => {
            if (result.code === this.$c.API_RES_CODE.SUCCESS) {
              this.myinfo.setting.ticket_price = key;
              this.but_group.trans.state = key;
              this.$perf.setString(this.$c.PREF_PARAMS.TICKET_PRICE, key);
              Utils.toast(this,this.$t('admin_point_setting.msg_update_success'));
            } else {
              Utils.toast(this,result.msg);
            }
          });
          break;
        case 'Y':
        case 'N':
          Utils.requestPost(
            this.$c.API.Admin.updateAppInfo,
            {
              param_name: 'ticket_show',
              value: key,
            }
          ).then(result => {
            if (result.code === this.$c.API_RES_CODE.SUCCESS) {
              this.myinfo.setting.ticket_show = key;
              this.but_group.display.state = key;
              this.$perf.setString(this.$c.PREF_PARAMS.TICKET_SHOW, key);
              Utils.toast(this,this.$t('admin_point_setting.msg_update_success'));
            } else {
              Utils.toast(this,result.msg);
            }
          });
          break;
        case 'community_made_point':
        case 'notify_made_point':
        case 'community_push_point':
        case 'notify_push_point':
          Utils.requestPost(
            this.$c.API.Admin.updateAppInfo,
            {
              param_name: key,
              value: this.items[key].chg_data,
            }
          ).then(result => {
            if (result.code === this.$c.API_RES_CODE.SUCCESS) {
              this.myinfo.setting[key] = this.zero(this.items[key].chg_data);
              this.items[key].cur_data = this.zero(this.items[key].chg_data);
              this.items[key].chg_data = null;
              Utils.toast(this,this.$t('admin_point_setting.msg_update_success'));
            } else {
              Utils.toast(this,result.msg);
            }
          });
          break;
      }
      this.$bvModal.hide(key);
    },
    zero(val){
      return val === null ? 0: val;
    }
  },
  mounted() {
    this.items.community_made_point.cur_data = this.myinfo.setting.community_made_point;
    this.items.notify_made_point.cur_data = this.myinfo.setting.notify_made_point;
    this.items.community_push_point.cur_data = this.myinfo.setting.community_push_point;
    this.items.notify_push_point.cur_data = this.myinfo.setting.notify_push_point;
    this.but_group.display.state = this.myinfo.setting.ticket_show;
    this.but_group.trans.state = this.myinfo.setting.ticket_price;
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';

.inline-input {
  height: 45px;
  display: inline-block;
  width:44%;
  text-align: center;
  font-size: 16px;
  font-family: $korean_gd_13_r;
  padding:8px;
}

.col {
  padding:0 0.1em 0 0.1em;
}

.col > button{
  width:95%;
  font-size: 0.99em;
  padding:0.7em 0 0.7em 0;
}

.row {
  margin-top:1em;
  align-items: center;
}

::placeholder{
  color:#c4c3c3;
}
.primary_btn{
  background-color: #267fff;
  width: 55px;
  height: 45px;
  border-radius: 3px;
  padding: 0;
  font-size: 14px;
  font-family: $korean_gd_15_r;
  color: white;
}
.inactive_btn{
  @extend .primary_btn;
  background-color: white;
  border: solid 1px black;
  color: black;
}
.confirm_btn{
  background-color: #0840ba;
  width: 60px;
  height: 38px;
  border-radius: 3px;
  padding: 0;
  font-size: 18px;
  font-family: $korean_gd_15_r;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminPeriod.vue